import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "typeface-roboto";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import AppLive from "./Live/App";
import AppVod from "./VOD/App";
import registerServiceWorker from "./registerServiceWorker";
import { HashRouter, Route, Switch } from "react-router-dom";

const theme = createMuiTheme({
  overrides: {
    MuiStepIcon: {
      completed: {
        color: "#4CAF50 !important"
      }
    }
  }
});

function ThemedApp() {
  return (
    <MuiThemeProvider theme={theme}>
      <HashRouter>
        <Switch>
          <Route path="/vod/player/:player" component={AppVod} />
          <Route path="/vod" component={AppVod} />
          <Route component={AppLive} />
        </Switch>
      </HashRouter>
    </MuiThemeProvider>
  );
}

ReactDOM.render(<ThemedApp />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js